import '../../css/flags.css';



(function ($) {
    let loadingForm = false;
    let formLoaded = false;

    function defineDemo() {
        conversiondata.push("hasdemo", true);
        conversiondata.push("defaultaccount", 2);
        conversiondata.push("factor", 1);
        conversiondata.push("expdays ", 700);

    }

    function defineSA() {
        conversiondata.push("saprocess", 1);
        window.postlead && window.postlead.push("saprocess", 1);
        window.fxo = {sa: true}; 
    }

    if ($('html').attr('lang') === 'cs') {
        $('html').attr('lang', 'cz');
    } else if ($('html').attr('lang') === 'ko') {
        $('html').attr('lang', 'kr');
    } else if ($('html').attr('lang') === 'zh-hans') {
        $('html').attr('lang', 'cn');
    }

    function initZA() {

        let agreeZA_clicked = false;

        if (!agreeZA_clicked) {
            $(".submitWrapper, #form-agreeZA input").click(function () {
                agreeZA_clicked = true;
                $('#form-agreeZA').addClass('clicked');
            });
        }
    }

    let brand_eu = languageAttributes.broker == '3' && languageAttributes.brand === 'iforex' || false;
    let brand = languageAttributes.broker == '3' && !brand_eu ? 'vestle' : 'iforex';

    let param_trigger = window.getparam('trigger');

    let script_link = languageAttributes.broker == '6' ? '/assets/bundles/' + brand + '/website/js/' + languageAttributes.registrationBundle + '.js' : '/registration-bundle-ext/iforex/'+languageAttributes.registrationBundle+'/main.js'+`?v=${BUILD_VERSION}`;



    function doScrolling() {

        if (!loadingForm) {
            loadingForm = true;
            if (!formLoaded) {
                const script = document.createElement('script');
                script.async = true;
                script.defer = true;
                script.src = script_link; 

                script.onload = () => {
                    $('#form').lpForm({
                        validationSuccessCallback: function (formInstance) {
                            var data = formInstance.data;
                            formInstance.completeForm();

                        }, phonePrefixPaddingLeft: '70px'
                    });


                    if ($('#demo-form').length > 0) {
                        defineDemo();
                    }

                    if ($('#formSA').length > 0) {
                        window.ct = 63;
                        defineSA();
                    }

                    if ($('#formSAreg').length > 0) {
                        defineSA();                       
                    }

                    if ($('#form-agreeZA').length > 0) { initZA(); }

                     if (languageAttributes.spokenLanguageCode == 'tw') {
                         window.ct = 44;
                     }

                    if ($('input#password').length > 0){
                        window.withJWT = 'yes';
                    }

                    let params = new URLSearchParams(document.location.search);
                    let demo_profile = params.get("demoprofile"); 
                    if(demo_profile && demo_profile === '15') {
                        conversiondata.push("hasdemo", true);
                        conversiondata.push("defaultaccount", 1);
                        conversiondata.push("factor", 1);
                        conversiondata.push("expdays", 14);
                    } else if (demo_profile) {
                        window.fetch(`https://content.webapi-services.net/api/demoProfiles?p=${demo_profile}`)
                        .then(response => {
                            if (response.ok) {
                                return response.json();
                            } else {
                                throw new Error('Network response was not ok');
                            }
                        })
                        .then(data => {
                            if (data && data.length > 0) {
                                
                                conversiondata.push("hasdemo", data[0].hasdemo);
                                conversiondata.push("defaultaccount", data[0].defaultaccount);
                                conversiondata.push("factor", data[0].factor);
                                conversiondata.push("expdays", data[0].expdays);
                            } else {
                                console.error('No demo profile found for the given parameter.');
                            }
                        })
                        .catch(error => {
                            console.error('There was a problem with the fetch operation:', error);
                        }
                        );
                    }



                };

                loadingForm = false;
                formLoaded = true;
                document.body.appendChild(script); 
                
            }
        }
    }

    window.scrollingTasks.push(doScrolling);

    window.callDoScrolling = true;
})(window.jQuery);
